export default [
  {
    path: '/config-yzxml',
    name: 'config-yzxml',
    component: () => import(/* webpackChunkName: "config" */ './Config-yzxml')
  }
]
